export default "__VITE_ASSET__ToGkIqd4__"